var _rect, _rect2, _rect3, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame3465990(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 150,
    viewBox: "0 0 158 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157.723,
    height: 149.5,
    transform: "translate(0.722656)",
    fill: "#265DF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.1797,
    y: 66.2991,
    width: 19.7237,
    height: 33.3831,
    transform: "rotate(48.3353 80.1797 66.2991)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 19.7237,
    height: 33.0648,
    transform: "matrix(-0.66477 0.747048 0.747048 0.66477 80.1113 66.5107)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.531 51.0735C113.364 48.7111 108.071 50.173 105.709 54.339L89.0539 83.7102C84.6015 91.5625 87.3574 101.538 95.2096 105.99L96.0795 106.484L120.797 62.8945L121.007 62.5005C123.064 58.4002 121.566 53.3623 117.531 51.0735Z",
    fill: "white",
    stroke: "#265DF5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1803 51.0735C46.3466 48.7111 51.6396 50.173 54.0022 54.339L70.6571 83.7102C75.1094 91.5625 72.3536 101.538 64.5014 105.99L63.6315 106.484L38.9144 62.8945L38.7044 62.5005C36.6467 58.4002 38.1446 53.3623 42.1803 51.0735Z",
    fill: "white",
    stroke: "#265DF5",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 55,
    r: 10,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3465990);
export default __webpack_public_path__ + "static/media/Frame 3465990.c05207d367aa63084379d7a14cf458c9.svg";
export { ForwardRef as ReactComponent };